import { c as _c } from "react/compiler-runtime";
import { ShieldExclamationIcon, UserGroupIcon, UserPlusIcon } from "@heroicons/react/24/outline";
import { ActionButton } from "./CreateWaveInlineGroupButtons";
export default function CreateWaveInlineGroupActions(t0) {
  const $ = _c(19);
  const {
    disabled,
    identityActive,
    ruleActive,
    searchActive,
    onAddIdentity,
    onAddRule,
    onUseExistingGroup
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <UserPlusIcon aria-hidden="true" className="tw-size-3.5 tw-flex-shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== disabled || $[2] !== identityActive || $[3] !== onAddIdentity) {
    t2 = <ActionButton icon={t1} label="Add identity" disabled={disabled} active={identityActive} isToggle={true} onClick={onAddIdentity} />;
    $[1] = disabled;
    $[2] = identityActive;
    $[3] = onAddIdentity;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ShieldExclamationIcon aria-hidden="true" className="tw-size-3.5 tw-flex-shrink-0" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled || $[7] !== onAddRule || $[8] !== ruleActive) {
    t4 = <ActionButton icon={t3} label="Add rule" disabled={disabled} active={ruleActive} isToggle={true} onClick={onAddRule} />;
    $[6] = disabled;
    $[7] = onAddRule;
    $[8] = ruleActive;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <UserGroupIcon aria-hidden="true" className="tw-size-3.5 tw-flex-shrink-0" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== disabled || $[12] !== onUseExistingGroup || $[13] !== searchActive) {
    t6 = <ActionButton icon={t5} label="Choose group" disabled={disabled} active={searchActive} isToggle={true} onClick={onUseExistingGroup} />;
    $[11] = disabled;
    $[12] = onUseExistingGroup;
    $[13] = searchActive;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t4 || $[17] !== t6) {
    t7 = <div className="tw-flex tw-flex-wrap tw-gap-1.5 md:tw-absolute md:tw-right-0 md:tw-top-0 md:tw-justify-end">{t2}{t4}{t6}</div>;
    $[15] = t2;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}